(function() {
    var STORAGE_KEY = 'halo_customer_info';

    if (!localStorage.getItem(STORAGE_KEY)) {
        window.customerInfoPopupPending = true;
    }

    document.addEventListener('DOMContentLoaded', function() {

        var popup = document.getElementById('halo-customer-info-popup');
        if (!popup) return;

        var form = popup.querySelector('#CustomerInfoPopup');

        var closeBtn = popup.querySelector('[data-close-customer-info-popup]');
        var submitBtn = popup.querySelector('[data-customer-info-submit]');
        var errorEl = popup.querySelector('[data-customer-info-error]');
        var nameInput = popup.querySelector('#CustomerInfoName');
        var emailInput = popup.querySelector('#CustomerInfoEmail');
        var phoneInput = popup.querySelector('#CustomerInfoPhone');


        function closePopup() {
            document.body.classList.remove('customer-info-show');
        }


        if (closeBtn) {
            closeBtn.addEventListener('click', function(e) {
                e.preventDefault();
                closePopup();
            });
        }


        document.addEventListener('click', function(e) {

            if (document.body.classList.contains('customer-info-show')) {

                if (
                    !popup.contains(e.target) &&
                    !e.target.closest('[data-btn-addtocart]')
                ) {
                    closePopup();
                }
            }

        });


        function replayAddToCart() {

            if (!window.customerInfoPopupTarget) {
                return;
            }

            var $target = window.customerInfoPopupTarget;

            window.customerInfoPopupTarget = null;


            if (window.customerInfoPopupQuickShop) {

                var quickShopPopup =
                    window.customerInfoPopupQuickShopPopup;

                window.customerInfoPopupQuickShop = false;
                window.customerInfoPopupQuickShopPopup = null;


                if (
                    quickShopPopup &&
                    window.halo &&
                    typeof window.halo.initAddToCartQuickShop === 'function'
                ) {

                    window.halo.initAddToCartQuickShop(
                        $target,
                        quickShopPopup
                    );
                }

            } else {

                $target.trigger('click');

            }
        }



        if (form) {

            form.addEventListener('submit', function(e) {

                e.preventDefault();


                var name = nameInput ?
                    nameInput.value.trim() :
                    '';

                var email = emailInput ?
                    emailInput.value.trim() :
                    '';

                var phone = phoneInput ?
                    phoneInput.value.trim() :
                    '';



                if (!name) {

                    if (errorEl) {
                        errorEl.textContent =
                            'Please enter your name.';
                    }

                    return;
                }


                if (!email) {

                    if (errorEl) {
                        errorEl.textContent =
                            'Please enter your email.';
                    }

                    return;
                }


                var emailValid =
                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                    .test(email);


                if (!emailValid) {

                    if (errorEl) {
                        errorEl.textContent =
                            'Please enter a valid email.';
                    }

                    return;
                }



                if (submitBtn) {

                    submitBtn.classList.add(
                        'is-loading'
                    );

                    submitBtn.disabled = true;
                }


                if (errorEl) {
                    errorEl.textContent = '';
                }



                // Save customer info for checkout
                var storedData = {
                    name: name,
                    email: email
                };


                if (phone) {
                    storedData.phone = phone;
                }


                localStorage.setItem(
                    STORAGE_KEY,
                    JSON.stringify(storedData)
                );


                window.customerInfoPopupPending = false;



                /*
                Existing Shopify contact submission
                Removed intentionally because client does not
                want subscriber creation.
                */



                closePopup();



                if (submitBtn) {

                    submitBtn.classList.remove(
                        'is-loading'
                    );

                    submitBtn.disabled = false;
                }



                replayAddToCart();

            });

        }



    });



    /*
    Redirect checkout with customer information
    */

    async function redirectToPrefilledCheckout() {

        try {


            var savedInfo =
                localStorage.getItem(STORAGE_KEY);



            if (!savedInfo) {

                window.location.href =
                    '/checkout';

                return;
            }



            var customerInfo =
                JSON.parse(savedInfo);



            var email =
                customerInfo.email ?
                customerInfo.email.trim() :
                '';



            var name =
                customerInfo.name ?
                customerInfo.name.trim() :
                '';



            if (!email) {

                window.location.href =
                    '/checkout';

                return;
            }



            var nameParts =
                name.split(/\s+/)
                .filter(Boolean);



            var firstName =
                nameParts.shift() || '';

            var lastName =
                nameParts.join(' ');



            var cartResponse =
                await fetch('/cart.js');



            var cart =
                await cartResponse.json();



            if (
                !cart.items ||
                !cart.items.length
            ) {

                window.location.href =
                    '/cart';

                return;
            }



            var cartItems =
                cart.items.map(function(item) {

                    return (
                        item.variant_id +
                        ':' +
                        item.quantity
                    );

                }).join(',');



            var params =
                new URLSearchParams();



            params.set(
                'checkout[email]',
                email
            );



            if (firstName) {

                params.set(
                    'checkout[shipping_address][first_name]',
                    firstName
                );
            }



            if (lastName) {

                params.set(
                    'checkout[shipping_address][last_name]',
                    lastName
                );
            }



            var checkoutUrl =
                '/cart/' +
                cartItems +
                '?' +
                params.toString();



            window.location.href =
                checkoutUrl;



        } catch(error) {


            console.error(
                'Checkout redirect error:',
                error
            );


            window.location.href =
                '/checkout';

        }

    }




    /*
    Intercept Flex cart drawer checkout button
    */

    document.addEventListener(
        'click',
        function(e) {


            var checkoutButton =
                e.target.closest(
                    '#cart-sidebar-checkout'
                );



            if (!checkoutButton) {
                return;
            }



            var savedInfo =
                localStorage.getItem(
                    STORAGE_KEY
                );



            if (!savedInfo) {

                return;

            }



            e.preventDefault();

            e.stopImmediatePropagation();



            redirectToPrefilledCheckout();



        },
        true
    );



})();